import { useSiteContent } from '@/hooks/useSiteContent';
import ContentState from '@/components/feature/ContentState';

interface HowItWorksData {
  title: string;
  highlight: string;
  steps: { number: string; title: string; description: string }[];
}

export default function HowItWorks() {
  const { data, loading, error, refresh } = useSiteContent<HowItWorksData>(
    'special_services_how_it_works',
  );

  if (loading || error || !data) {
    return <ContentState loading={loading} error={error} ready={!!data} onRetry={refresh} />;
  }

  return (
    <section className="w-full bg-background-200 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 text-center mb-12 md:mb-16">
            {data.title}{' '}
            <span className="text-primary-500">{data.highlight}</span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {data.steps.map((step) => (
              <div
                key={step.number}
                className="relative bg-background-50 border border-background-200/70 rounded-xl p-6"
              >
                <div className="font-heading text-3xl md:text-4xl font-bold text-accent-500 mb-4">
                  {step.number}
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}